import httpManager from "@/app/shared/utils/httpManager";

/**
 * Creates manually a contact.
 *
 * @param {number} contactData Contact data with the portfolioId.
 */
export async function createContact(contactData) {
  await httpManager.post(`/contacts/clients/create/`, contactData);
}
